import React from "react";
import { connect } from "react-redux";
import Button from "components/button";
import { Download, FileText } from "lucide-react";
import Card from "components/card";

const DocumentInfo = ({ 
    document,
    hasAction,
    hasBorder,
}) => {
    if (!document) return null;

    const statusClass = document.status.toLowerCase().replace(/\s+/g, "-");
    
    return (
        <Card className="grid w-full gap-4 border rounded-lg shadow-lg p-6">
            <div className="flex flex-col gap-2 text-left">
                <h2 class="label-gradient emerald text-[20px] font-semibold">
                    {document.title}
                </h2>
                <p className="flex gap-1 text-sm font-medium text-slate-700">
                    <span>{document.type}</span>
                    <span>•</span>
                    <span>{document.date}</span>
                    <span>•</span>
                    <span>{document.size}</span>
                </p>

            </div>
            <div className="space-y-6 pt-4">
                <div className="flex flex-col gap-6 rounded-xl border border-slate-200">
                    <div
                    className={`
                        grid auto-rows-min items-start gap-1.5 px-6 pt-6
                        ${hasAction ? "grid-cols-[1fr_auto]" : "grid-cols-1"}
                        ${hasBorder ? "pb-6 border-b" : ""}
                    `}
                    >
                        <h4 className="text-[16px]">Document Information</h4>
                    </div>
                    <div className="px-6 pb-6 space-y-3">
                        <div className="grid grid-cols-2 gap-4">
                            <div>
                                <p className="text-[12px] text-slate-700">Document ID</p>
                                <p className="font-medium text-[14px]">{document.docID}</p>
                            </div>
                                <div>
                                <p className="text-[12px] text-slate-700">Status</p>
                                <span className={`status-indicator ${statusClass}`}>
                                    {document.status}
                                </span>
                            </div>
                                <div>
                                <p className="text-[12px] text-slate-700">Date Issued</p>
                                <p className="font-medium text-[14px]">{document.date}</p>
                            </div>
                            <div>
                                <p className="text-[12px] text-slate-700">Document Type</p>
                                <p className="font-medium text-[14px]">{document.type}</p>
                            </div>
                        </div>
                        <div className="bg-gray-200 h-px w-full my-6"></div>
                        <div>
                            <p className="text-[12px] mb-2 text-slate-700">Description</p>
                            <p className="text-[14px]">{document.description}</p>
                        </div>
                        <div className="bg-gray-200 h-px w-full my-6"></div>
                        {document.prevSalary && document.newSalary && document.increase && (
                            <div className="grid grid-cols-3 gap-4">
                                <div>
                                    <p className="text-[12px] text-slate-700">Previous Salary</p>
                                    <p className="font-medium text-[14px]">{document.prevSalary}</p>
                                </div>
                                <div>
                                    <p className="text-[12px] text-slate-700">New Salary</p>
                                    <p className="font-medium text-[14px] text-emerald-600">{document.newSalary}</p>
                                </div>
                                <div>
                                    <p className="text-[12px] text-slate-700">Increase</p>
                                    <p className="inline-flex items-center justify-center rounded-lg px-2 py-0.5 text-xs font-medium bg-emerald-100 text-emerald-700">{document.increase}</p>
                                </div>
                                <div>
                                    <p className="text-[12px] text-slate-700">Effective Date</p>
                                    <p className="font-medium text-[14px]">{document.effectiveDate}</p>
                                </div>
                            </div>
                        )}

                        {document.previousRole && document.newRole && (
                            <div className="grid grid-cols-2 gap-4">
                                <div>
                                    <p className="text-[12px] text-slate-700">Previous Role</p>
                                    <p className="font-medium text-[14px]">{document.previousRole}</p>
                                </div>
                                <div>
                                    <p className="text-[12px] text-slate-700">New Role</p>
                                    <p className="font-medium text-[14px] text-purple-600">{document.newRole}</p>
                                </div>
                                <div>
                                    <p className="text-[12px] text-slate-700">Effective Date</p>
                                    <p className="font-medium text-[14px]">{document.effectiveDate}</p>
                                </div>
                            </div>
                        )}

                        {document.bonus && document.reason && (
                            <div className="grid grid-cols-2 gap-4">
                                <div>
                                    <p className="text-[12px] text-slate-700">Bonus Amount</p>
                                    <p className="font-medium text-[16px] text-emerald-600">{document.bonus}</p>
                                </div>
                                <div>
                                    <p className="text-[12px] text-slate-700">Reason</p>
                                    <p className="font-medium text-[14px]">{document.reason}</p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <div className="flex flex-col gap-6 rounded-xl border border-slate-200 bg-slate-50">
                    <div className="pb-6 p-8">
                        <div className="flex flex-col items-center justify-center space-y-4 py-12">
                            <div className="p-4 rounded-full bg-slate-200">
                                <FileText className="w-12 h-12 text-slate-500" />
                            </div>
                            <div className="text-center space-y-2">
                                <p className="text-[14px] font-medium">Document Preview</p>
                                <p className="text-[12px] max-w-md text-slate-700">
                                    Preview functionality would display the actual document content here. 
                                    Click download to get the full document.
                                </p>
                                <Button
                                    type="button"
                                    className="access-button btn-emerald h-8"
                                >
                                    <Download className="w-4 h-4 mr-2"/>
                                    <span className="text-sm font-medium">Download Full Document</span>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Card>
    );
};

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(DocumentInfo);
